import React from "react";
import {
    closestCenter,
    DndContext,
    DragEndEvent,
    DragStartEvent,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import {
    SortableContext,
    sortableKeyboardCoordinates,
    useSortable,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {useTranslation} from "react-i18next";
import "../../i18n/config";
import {useSetStyleRegistory} from "../../hooks/useSetStyleRegistory";
import {ContentKey} from "../../models/Keys";
import {ContentHeader} from "../../models/ContentHeader";
import {Tooltip} from "../common/Tooltip";
import {RCCellHeaderProps} from "./RCCellHeaderProps";
import {MultiLineTextEditor} from "../common/MultilineTextEditor";


type ContentHeaderCellProps = {
    content_header: ContentHeader
    readOnly: boolean;
    onRemove?: (key: ContentKey) => void;
    onNameChange?: (key: ContentKey, name: string) => void;
    id: string

    onHide: () => void;
    onShow: () => void;
}
const RCContentHeaderCell = (props: ContentHeaderCellProps) => {
    const {t} = useTranslation();
    const [isEdit, setIsEdit] = React.useState(false);
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        // transition,
    } = useSortable({id: props.id});
    if (transform) {
        // y 方向に固定
        transform.x = 0;
        transform.scaleX = 1;
        transform.scaleY = 1;
    }

    const style = {
        transform: CSS.Transform.toString(transform),
        //transition ?? '',
    } as React.CSSProperties;

    const setStyleRegistry = useSetStyleRegistory();
    setStyleRegistry.dispatch(props.content_header.Key, style);

    const handleEditEnd = (value: string, isCancel: boolean) => {
        if (!isCancel && props.content_header.Name !== value) {
            props.onNameChange?.(props.content_header.Key, value);
        }
        setIsEdit(false);
    }

    const handleEyeClick = () => {
        props.content_header.IsHidden ? props.onShow() : props.onHide();
    }

    return (
        <div {...attributes}
             className="content_header_cell"
             ref={setNodeRef}
             onClick={() => !props.readOnly && setIsEdit(true)}
             role={undefined} /* attributes で指定されるのを抑制 */
             style={style}
        >
            {props.content_header.IsHidden
                ? <span className="hidden_line"/>
                : <MultiLineTextEditor value={props.content_header.Name} isEdit={isEdit} onEditEnd={handleEditEnd}/>
            }
            <div className="grab-ui" data-enabled={!props.readOnly} onClick={e => e.stopPropagation()}>
                <Tooltip title={t("上下移動")}>
                    <span className="grab-ui-button vertical_move" {...listeners} />
                </Tooltip>
                <Tooltip title={props.content_header.IsHidden ? t("表示") : t("非表示")}>
                    <span className={`grab-ui-button ${props.content_header.IsHidden ? 'display' : 'hidden'}`}
                          onClick={handleEyeClick}/>
                </Tooltip>
                <Tooltip title={t("削除")}>
                    <span className="grab-ui-button delete" onClick={() => props.onRemove?.(props.content_header.Key)}/>
                </Tooltip>
            </div>

        </div>
    )
}

export const RCContentHeader = (props: RCCellHeaderProps<ContentHeader>) => {
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const handleDragStart = (event: DragStartEvent) => {

    }

    const keys = props.mgr.ContentHeaders.Keys;
    const handleDragEnd = (event: DragEndEvent) => {
        const {active, over} = event;

        if (over && active.id !== over.id) {
            props.onDragEnd?.(active.id as ContentKey, over.id as ContentKey);
        }
    }

    return (
        <div className="content_header" style={props.style}>
            <DndContext sensors={sensors} collisionDetection={closestCenter}
                        onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                <SortableContext items={keys} strategy={verticalListSortingStrategy}>
                    {props.mgr.ContentHeaders.map(
                        cell =>
                            <RCContentHeaderCell key={cell.Key}
                                                 id={cell.Key}
                                                 content_header={cell}
                                                 readOnly={props.readOnly}
                                                 onRemove={props.onRemove}
                                                 onNameChange={props.onNameChange}
                                                 onHide={() => props.onHide?.(cell.Key)}
                                                 onShow={() => props.onShow?.(cell.Key)}
                            />
                    )}
                </SortableContext>
            </DndContext>
        </div>
    );
}
